import type { CSSProperties } from 'react';

type IconDefinition = readonly [path: string, viewBox: number];

const ICON_PATHS = {
  dashboard: ['M3 13H11V3H3V13ZM3 21H11V15H3V21ZM13 21H21V11H13V21ZM13 3V9H21V3H13Z', 24],
  refer: [
    'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zM6 10V7H4v3H1v2h3v3h2v-3h3v-2H6z',
    24,
  ],
  reporting: [
    'M13.75 3.333H16.25V16.667H13.75V3.333ZM3.75 11.667H6.25V16.667H3.75V11.667ZM8.75 7.5H11.25V16.667H8.75V7.5Z',
    20,
  ],
  partners: ['M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z', 24],
  assets: [
    'M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5 11 16.51 14.5 12 19 18H5l3.5-4.5Z',
    24,
  ],
  team: [
    'M8 8.5c1.087 0 2.047.26 2.827.6.72.32 1.173 1.04 1.173 1.82V12H4v-1.073c0-.787.453-1.507 1.173-1.82.78-.347 1.74-.607 2.827-.607ZM2.667 8.667a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Zm.753.733A4.02 4.02 0 0 0 2.667 9.333c-.66 0-1.287.14-1.854.387C.32 9.933 0 10.413 0 10.953V12h3v-1.073c0-.554.153-1.074.42-1.527Zm9.913-.733a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667ZM16 10.953c0-.54-.32-1.02-.813-1.233A4.63 4.63 0 0 0 13.333 9.333c-.26 0-.506.027-.753.067.266.453.42.973.42 1.527V12h3v-1.047ZM8 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z',
    16,
  ],
  profile: [
    'M8 8.667A4 4 0 1 0 8 .667a4 4 0 0 0 0 8ZM8 10.333c-3.314 0-6 2.02-6 4.51v.49h12v-.49c0-2.49-2.686-4.51-6-4.51Z',
    16,
  ],
  logout: [
    'M17 7 15.59 8.41 18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5ZM4 5h8V3H4C2.9 3 2 3.9 2 5v14c0 1.1.9 2 2 2h8v-2H4V5Z',
    24,
  ],
  eye: [
    'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z',
    24,
  ],
  menu: ['M2.75 3.5h10.5v1.4H2.75zM2.75 7.3h10.5v1.4H2.75zM2.75 11.1h10.5v1.4H2.75z', 16],
  calendar: [
    'M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 16H5V10h14v10Zm0-12H5V6h14v2Z',
    24,
  ],
  copy: [
    'M16 1H4C2.9 1 2 1.9 2 3v14h2V3h12V1ZM19 5H8C6.9 5 6 5.9 6 7v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16H8V7h11v14Z',
    24,
  ],
  close: [
    'M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
    24,
  ],
  check: ['M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z', 24],
  plus: ['M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z', 24],
  upload: ['M9 16h6v-6h4l-7-7-7 7h4v6zm-4 2h14v2H5v-2z', 24],
  download: ['M5 20H19V18H5V20ZM19 9H15V3H9V9H5L12 16L19 9Z', 24],
  image: [
    'M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.5 13.5 11 16.51 14.5 12 19 18H5L8.5 13.5Z',
    24,
  ],
  deck: [
    'M21 3H3V5H4V17C4 18.1 4.9 19 6 19H11V21H8V23H16V21H13V19H18C19.1 19 20 18.1 20 17V5H21V3ZM18 17H6V5H18V17ZM8 12H10V15H8V12ZM11 8H13V15H11V8ZM14 10H16V15H14V10Z',
    24,
  ],
  doc: [
    'M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z',
    24,
  ],
  trash: [
    'M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z',
    24,
  ],
  folder: [
    'M10 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2Z',
    24,
  ],
  sales: [
    'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Z',
    24,
  ],
  orders: [
    'M6 2h9l5 5v15H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm8 1.5V8h4.5L14 3.5ZM8 12h8v1.6H8V12Zm0 4h8v1.6H8V16Z',
    24,
  ],
  commission: [
    'M11.1 2h1.8v4.3l3-3 1.3 1.3-3 3H18.5v1.8h-4.3l3 3-1.3 1.3-3-3V18h-1.8v-4.3l-3 3-1.3-1.3 3-3H5.3v-1.8h4.3l-3-3 1.3-1.3 3 3V2Z',
    24,
  ],
  conversion: ['M4 19h2.4v-6H4v6Zm5.3 0h2.4V5H9.3v14Zm5.3 0H17V9.5h-2.4V19Z', 24],
  visitors: [
    'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 2c-4.4 0-8 2.2-8 4.9V21h16v-2.1c0-2.7-3.6-4.9-8-4.9Z',
    24,
  ],
  time: ['M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm.9 5v5.4l4.2 2.5-.9 1.5-5.1-3V7h1.8Z', 24],
  pages: ['M4 4h16v3H4V4Zm0 5h16v2H4V9Zm0 4h11v2H4v-2Zm0 4h11v2H4v-2Z', 24],
  engagement: [
    'M2 11h4.2l2.1-5.4a1 1 0 0 1 1.9.1l3 10.3 2-4.5a1 1 0 0 1 .9-.6H22v2h-4.3l-2.8 6.3a1 1 0 0 1-1.9-.1l-3-10.4-1.5 3.9a1 1 0 0 1-.9.6H2v-2Z',
    24,
  ],
  forecast: [
    'M3 17.6 9.2 11.4l3.4 3.4L19.1 8.3 21 10.2l-8.4 8.4-3.4-3.4L4.9 19.5 3 17.6Zm14.4-9.3V6h4.2v4.2h-2.1V8.3h-2.1Z',
    24,
  ],
  settings: [
    'M19.14 12.94a7.07 7.07 0 0 0 0-1.88l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.03 7.03 0 0 0-1.63-.94l-.36-2.54a.5.5 0 0 0-.5-.42h-3.84a.5.5 0 0 0-.49.42l-.36 2.54c-.59.24-1.13.56-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.66 8.84a.5.5 0 0 0 .12.64l2.03 1.58a7.07 7.07 0 0 0 0 1.88L2.78 14.5a.5.5 0 0 0-.12.64l1.92 3.32c.13.22.4.31.6.22l2.39-.96c.5.38 1.04.7 1.63.94l.36 2.54c.05.24.25.42.49.42h3.84c.25 0 .45-.18.5-.42l.36-2.54c.59-.24 1.13-.56 1.63-.94l2.39.96c.2.09.47 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58Z',
    24,
  ],
  statements: [
    'M19 2H5a2 2 0 0 0-2 2v18l3-2 3 2 3-2 3 2 3-2 3 2V4a2 2 0 0 0-2-2zm-2 6H7V6h10v2zm0 4H7v-2h10v2zm-4 4H7v-2h6v2z',
    24,
  ],
} as const satisfies Record<string, IconDefinition>;

const ICON_STROKES = {
  'arrow-left': ['M19 12H5 M11 18l-6-6 6-6', 24],
  'arrow-right': ['M4 12h15M13 6l6 6-6 6', 24],
  'level-up': ['M19 19h-9a4 4 0 0 1-4-4V7 M2 11l4-4 4 4', 24],
  'chevron-down': ['M6 9l6 6 6-6', 24],
  'chevron-right': ['M9 6l6 6-6 6', 24],
} as const satisfies Record<string, IconDefinition>;

export type IconName = keyof typeof ICON_PATHS | keyof typeof ICON_STROKES;

export interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  title?: string;
  style?: CSSProperties;
}

/** Single-colour glyph from the Partner Portal icon vocabulary. */
export function Icon({ name, size = 16, color = 'currentColor', title, style }: IconProps) {
  const stroke = name in ICON_STROKES ? ICON_STROKES[name as keyof typeof ICON_STROKES] : undefined;
  const filled = name in ICON_PATHS ? ICON_PATHS[name as keyof typeof ICON_PATHS] : undefined;
  const [path, viewBox] = stroke ?? filled ?? ['', 24];
  const paths = path.split(' M').map((value, index) => (index === 0 ? value : `M${value}`));

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${viewBox} ${viewBox}`}
      fill={stroke ? 'none' : color}
      stroke={stroke ? color : undefined}
      strokeWidth={stroke ? 2 : undefined}
      strokeLinecap={stroke ? 'round' : undefined}
      strokeLinejoin={stroke ? 'round' : undefined}
      style={{ display: 'block', flex: '0 0 auto', ...style }}
      aria-hidden={title ? undefined : true}
      {...(title ? { role: 'img' } : {})}
    >
      {title ? <title>{title}</title> : null}
      {paths.map((item, index) => (
        <path key={index} d={item} />
      ))}
    </svg>
  );
}
